import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Sign from "../assets/images/sign.png";
import Divider from "@mui/material/Divider";
import Mic from "../assets/icons/mic.png";
import logo from "../assets/icons/logo.png";
import Clapperboard from "../assets/icons/clapperboard.png";
import { MADE_WITH_LOVE_TEXT } from "./LeftMenuSmallScreen";
import "../styles/MadeWithLove.css";
import { IconButton } from "@mui/material";

const MadeWithLove = ({ open, handleClose }) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: (theme) => theme.palette.primary.light,
              paddingInline: 1,
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="prihaniway"
              className="md-logo-smallScreen"
              sx={{ mt: 0, width: "50px" }}
            />

            <Box className="md-text" sx={{ pb: "4px", pt: "4px" }}>
              <Typography variant="h6" fontSize={18} fontWeight={700}>
                Prihani Way
              </Typography>
              <Typography variant="body2" sx={{ mt: "-2px" }}>
                E-Book
              </Typography>
              <Typography variant="body2" sx={{ mt: "-6px" }}>
                Website
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={handleClose} sx={closeButtonStyle}>
            x
          </IconButton>
          <Box sx={{ p: 2 }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                variant="h5"
                color="white"
                sx={{ mb: 2 }}
                className="madeWithLove-title"
              >
                Pirhani Way E-Book Website
              </Typography>
              <Typography color="white" className="madeWithLove-text">
                {MADE_WITH_LOVE_TEXT}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Typography
                  variant="body1"
                  color="white"
                  className="ceoSection"
                >
                  Ali Pirhani <br />
                  CEO
                </Typography>
                <Box
                  component="img"
                  src={Sign}
                  alt="prihaniway-sign"
                  className="signSection"
                  sx={{ ml: 2, width: "60px" }}
                />
              </Box>
            </Box>
            <Divider
              sx={{
                backgroundColor: (theme) => theme.palette.secondary.main,
                mt: 2,
                mb: 2,
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  pl: 1,
                  mt: 2,
                }}
                className="audioSection"
              >
                <Box
                  component="img"
                  src={Mic}
                  alt="microphone"
                  className="md-mic-smallScreen"
                  sx={{ mr: 2, width: "20px" }}
                />
                <Typography
                  variant="body2"
                  children="Dr Ali Pirhani"
                  color="white"
                />
              </Box>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  pl: 1,
                  mt: 2,
                }}
                className="developersSection"
              >
                <Box
                  component="img"
                  src={Clapperboard}
                  alt="developers"
                  className="md-mic-smallScreen"
                  sx={{ mr: 2, ml: "auto", width: "30px" }}
                />
                <Typography variant="body2" color="white">
                  Alireza Haji Mohammad <br />
                  Farshid Manoochehri <br />
                  Mahdi Rasa <br />
                  Amir Beigi <br />
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default MadeWithLove;

const style = {
  position: "absolute",

  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50vw",
  minWidth: "500px",
  minHeight: "300px",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  backgroundColor: (theme) => theme.palette.primary.dark,
};

const closeButtonStyle = {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pb: "10px",
  top: "-14px",
  right: "-14px",
  width: "25px",
  height: "25px",
  fontSize: "15px",
  bgcolor: (theme) => theme.palette.primary.dark,
  border: (theme) => `1px solid ${theme.palette.secondary.main}`,
  color: (theme) => theme.palette.secondary.main,
  tranition: "all 0.5s linear",
  "&:hover": {
    bgcolor: (theme) => theme.palette.secondary.main,
    border: (theme) => `1px solid ${theme.palette.primary.dark}`,
    color: (theme) => theme.palette.primary.dark,
  },
};
